import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ProductService } from 'src/app/product/product.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Product } from 'src/typings';

@Component({
  selector: 'app-folder-add-to-product',
  templateUrl: './add-to-product.component.html',
  styleUrls: ['./add-to-product.component.scss']
})
export class AddToProductComponent {
  @Input() product: Product | undefined;

  @Output() doneEvent: EventEmitter<Product> = new EventEmitter();

  folderControl: UntypedFormControl = new UntypedFormControl();

  constructor(
    private productsService: ProductService,
    private notificationService: NotificationService
  ) {}

  async add() {
    if (!this.product) return this.notificationService.warning(`Нет продукта!`);
    if (!this.folderControl.value || !this.folderControl.value.id)
      return this.notificationService.warning('Не выбрана папка!');
    const newProduct = await this.productsService
      .addFolder({
        product_id: this.product?.id,
        folder_id: this.folderControl.value.id
      })
      .toPromise();
    this.doneEvent.emit(newProduct);
    return;
  }
}
